export const mapAgeToColor = (
  age: number
): 'success' | 'yellow' | 'warning' | 'error' | 'purple' => {
  if (age <= 1) return 'success';

  if (age === 2) return 'yellow';

  if (age === 3) return 'warning';

  if (age <= 10) return 'error';

  return 'purple';
};

const TIME_TOLERANCE_MS = 1000;
const MAX_CLOCK_SKEW_MS = 50;

export const isUpdateCausedByLastMessage = (
  detailUpdatedDateTime?: string | null,
  lastMessageSentDate?: string | null
): boolean => {
  if (!detailUpdatedDateTime || !lastMessageSentDate) return false;

  const updatedAt = Date.parse(detailUpdatedDateTime);
  const sentAt = Date.parse(lastMessageSentDate);

  if (Number.isNaN(updatedAt) || Number.isNaN(sentAt)) return false;

  return (
    updatedAt + MAX_CLOCK_SKEW_MS >= sentAt && Math.abs(updatedAt - sentAt) <= TIME_TOLERANCE_MS
  );
};
